import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, InputAdornment, Typography } from "@mui/material";
import RegisterApi from 'api/counter/register.api';
import ClinicApi from 'api/master/clinic.api';
import HeaderCard from "component/CardCustom/HeaderCard";
import { notiError } from 'component/notifications/notifications';
import TableRowExport from 'component/Pdf/TableRowExport';
import { ChipDoctor, ChipRemark, ChipTx } from 'component/Register/style/styleTreatmentHistory';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import _ from 'lodash';
import moment from 'moment';
import DropdownButton from 'new-components/buttons/dropdown-button';
import MainButton from 'new-components/buttons/main-button';
import DateRangeInput, { emptyRangePicker } from 'new-components/inputs/date-range-input';
import SelectInput from 'new-components/inputs/select-input';
import TextInput from "new-components/inputs/text-input";
import AlertModal from 'new-components/modal/alert-modal';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { routeName } from 'routes/routes-name';
import { getBranch, numberFormat, toBuddhistYear } from 'utils/app.utils';
import { dateTimeToView } from 'utils/date.utils';
import ExportToExcel from './ExportToExcel';

export default function NhsoTreatment() {
    const { t } = useTranslation()
    const history = useHistory()
    const componentRef = useRef<any>(null)
    const momentNowRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
    const momentDate = () => momentNowRange

    const [search, setSearch] = useState<string>('');
    const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
    const [branches, setBranches] = useState<any[]>([])
    const [branchId, setBranchId] = useState<any>(getBranch())
    const [status, setStatus] = useState('ALL');
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createAt')
    const [sortType, setSortType] = useState('DESC')

    const [treatments, setTreatments] = useState<any>([])
    const [exportData, setExportData] = useState<any>([])
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [activeFilters, setActiveFilters] = useState({
        search: search,
        rangeDate: rangeDate,
        branchId: branchId,
        status: status,
    })

    const [rangeDateExcel, setRangeDateExcel] = useState<string[]>(momentDate)
    const [branchIdExcel, setBranchIdExcel] = useState<any>(getBranch())
    const [statusExcel, setStatusExcel] = useState('ALL');
    const [messageError, setMessageError] = useState('')

    useEffect(() => {
        ClinicApi.findAllBranches()
            .then(({ data }) => setBranches(data))
            .catch((e) => { return })
    }, [])

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const loadData = async () => {
        try {

            let condition = {}
            condition = {
                page: page,
                pageLimit: pageLimit,
                search: search,
                sortBy: sortBy,
                sortType: sortType,
                dateStart: rangeDate[0],
                dateEnd: rangeDate[1],
                branchId: branchId === 0 ? null : branchId,
                status: status === 'ALL' ? '' : status
            }
            const resp = await RegisterApi.getNhsoTreatment(condition)
            const respExport = await RegisterApi.getNhsoTreatment({
                ...condition, export: 1, page: 1, pageLimit: 1000
            })
            if (resp.status === 200) {
                setRowCount(resp.headers['x-total'])
                setTreatments(resp.data)
                setExportData(respExport.data)
                setRangeDateExcel(rangeDate)
                setBranchIdExcel(branchId)
                setStatusExcel(status)
            } else {
                setTreatments([])
                setExportData([])
            }
        } catch (error) {
            notiError('error loadData')
        }
    }

    useEffect(() => {
        loadData()
    }, [page, pageLimit, sortBy, sortType])

    const checkStatusClaim = async (patientId: number, patientCaseId: number) => {
        if (patientId && patientCaseId) {
            await RegisterApi.getNhsoCheckStatus(patientCaseId).then(() => history.push(routeName.editNhsoTreatment, { patientId: patientId, patientCaseId: patientCaseId })).catch((error) => {
                setMessageError(error.response.data?.message)
                setIsOpenAlertModal(true)
            })
        }
    }

    const headCells = [
        { id: 'no', disablePadding: false, label: t('TABLE.NO'), width: '50px' },
        { id: 'recommendText', disablePadding: false, align: 'left', label: t('VN') },
        { id: 'date', disablePadding: false, align: 'left', label: t('วันที่รับบริการ') },
        { id: 'patientId', disablePadding: false, align: 'left', label: t('รหัสผู้ป่วย') },
        { id: 'patientName', disablePadding: false, align: 'left', label: t('ชื่อผู้ป่วย') },
        { id: 'service', disablePadding: false, align: 'left', label: t('การรักษา/บริการ'), width: '300px' },
        { id: 'price', disablePadding: false, label: t('ยอดค่าใช้จ่าย') },
        { id: 'status', disablePadding: false, label: t('สถานะเบิกจ่าย') },
        { id: 'updatedBy', disablePadding: false, label: t('ผู้บันทึก/เจ้าหน้าที่') },
        { id: 'action', disablePadding: false, label: 'Action', class: 'py-3' }
    ]

    const renderData = (objData: any, no: number, valueExportData: boolean) => {
        const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
        const groupedByDoctor = Object.values(
            objData?.treatments.reduce((acc: any, item: any) => {
                if (!acc[item.userFullname]) {
                    acc[item.userFullname] = {
                        userFullname: item.userFullname,
                        treatments: []
                    }
                }
                acc[item.userFullname].treatments.push(item)
                return acc
            }, {})
        )
        const objRenderData = {
            key: objData?.patientId,
            id: objData?.patientId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: num },
                { option: 'TEXT', align: 'left', label: objData?.vnNumber || '-' },
                { option: 'TEXT', align: 'left', label: objData?.date ? moment(objData?.date).add(543, 'year').format('DD/MM/YYYY') : '-' },
                { option: 'TEXT', align: 'left', label: objData?.cnNumber || '-' },
                { option: 'TEXT', align: 'left', label: objData?.patientFullname || '-' },
                {
                    option: 'COMPONENT', align: 'left', component: (<Box>
                        {groupedByDoctor?.map((item: any, index: number) => (
                            <>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}> <ChipDoctor label={'Dr.'} size="small" sx={{ width: '30px', height: '30px' }} /> {item?.userFullname}</Box>
                                {item?.treatments?.map((data: any, i: number) =>
                                    <>
                                        <Box key={i} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'start', marginTop: '1px' }}>
                                            <ChipTx label={'Tx.'} size="small" sx={{ width: '30px', height: '30px' }} /> {data?.operativeName}
                                        </Box>
                                        <Box key={i} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'start', marginTop: '1px' }}>
                                            <ChipRemark label={'Note.'} size="small" sx={{ width: '50px', height: '30px' }} /> {data?.note}
                                        </Box>
                                    </>)}
                            </>

                        ))}
                    </Box>)
                },
                { option: 'TEXT', align: 'right', label: numberFormat(objData?.price) },
                { option: 'TEXT', align: 'center', label: objData?.statusClaim === '1' ? 'รอเบิกจ่าย' : 'เบิกจ่ายสำเร็จ' },
                { option: 'UPDATE_BY', align: 'left', width: '120px', label: { updatedBy: objData?.updatedBy || '-', updatedAt: objData?.updatedAt || '-' } },
                { option: 'COMPONENT', align: 'center', component: <MainButton title={t('BUTTON.EDIT')} type='primary' variant='outlined' style={{ width: '80px' }} onClick={() => checkStatusClaim(objData?.patientId, objData?.patientCaseId)} /> }
            ]
        }
        return (
            <>
                {valueExportData === true && <TableRowExport {...objRenderData} /> ||
                    <TableRowCommon {...objRenderData} />
                }
            </>
        )
    }

    const renderDataExcel = (data: any) => {
        const groupedByDoctor = Object.values(
            data?.treatments.reduce((acc: any, item: any) => {
                if (!acc[item.userFullname]) {
                    acc[item.userFullname] = {
                        userFullname: item.userFullname,
                        treatments: []
                    }
                }
                acc[item.userFullname].treatments.push(item)
                return acc
            }, {})
        )

        return (
            <Box>
                {groupedByDoctor?.map((item: any, index: number) => (
                    <>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            {'Dr.'} {item?.userFullname}</Box>
                        {item?.treatments?.map((data: any, i: number) =>
                            <>
                                <Box key={i} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'start', marginTop: '1px' }}>
                                    {'Tx.'} {data?.operativeName}
                                </Box>
                                <Box key={i} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'start', marginTop: '1px' }}>
                                    {'Note.'} {data?.note}
                                </Box>
                            </>)}
                    </>

                ))}
            </Box>
        )
    }




    return (
        <Box>
            <AlertModal
                type='warning'
                title='ไม่สามารถแก้ไขได้'
                message={messageError === "VISIT_NOT_FOUND" ? 'เนื่องจากสิทธิสปสช.ของรายการนี้ถูกยกเลิก\nกรุณาตรวจสอบหรือยกเลิกใบเสร็จก่อนดำเนินการอีกครั้ง' : 'เนื่องจากรายการถูกส่งเบิกแล้ว'}
                isOpen={isOpenAlertModal}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false) }}
                onSubmit={{ onClick: () => null }}
                onCloseSubmit
            />
            <HeaderCard text="จัดการข้อมูลย้อนหลังการรักษา (สิทธิ์ สปสช.)" />
            <Box paddingX="24px" paddingTop="16px">
                <Grid container spacing="16px">
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <TextInput
                            label={t('REPORT.REPORT_NAME.SEARCH_NHSO_TREATMENT')}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            fullWidth
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <DateRangeInput
                            label=''
                            onchange={(val) => {
                                if (_.isEmpty(val)) setRangeDate(['', ''])
                                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                            }}
                            value={rangeDate || emptyRangePicker}
                            allowClear
                            onClear={() => setRangeDate(emptyRangePicker)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <SelectInput
                            label={t('REPORT.FILTER.BRANCH')}
                            value={branchId}
                            onChange={e => {
                                setBranchId(e.target.value)
                            }}
                            options={[
                                { value: 0, name: t('REPORT.REPORT_GROUP.ALL') },
                                ...branches.map(b => ({
                                    value: b.branchId,
                                    name: b.branchName || b.branchNameEn || ''
                                }))]}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <SelectInput
                            label={t('REPORT.FILTER.APPOINTMENT_STATUS')}
                            value={status}
                            onChange={e => setStatus(e.target.value)}
                            options={[
                                { value: "ALL", name: t('REPORT.FILTER.ALL') },
                                { value: "WAITING", name: t('รอเบิกจ่าย') },
                                { value: "CLAIM", name: t('เบิกจ่ายสำเร็จ ') },
                            ]}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={4}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                            <MainButton
                                title={t('INPUT.SEARCH')}
                                onClick={() => {
                                    setPage(1)
                                    setActiveFilters({
                                        search: search,
                                        rangeDate: rangeDate,
                                        branchId: branchId,
                                        status: status,
                                    })
                                    loadData()
                                }}
                                type={'primary'}
                                variant={'contained'}
                                style={{ width: '120px' }}
                            />
                            <DropdownButton title='พิมพ์เอกสาร' onChange={async (e) => {
                                if (e === 'Excel') {
                                    await ExportToExcel({
                                        title: t('จัดการข้อมูลย้อนหลังการรักษา (สิทธิ์ สปสช.)'),
                                        data: exportData,
                                        branchName: activeFilters.branchId !== 0 ? _.get(_.find(branches, { branchId: activeFilters.branchId }), 'branchName') || _.get(_.find(branches, { branchId: activeFilters.branchId }), 'branchNameEn') : t('REPORT.REPORT_GROUP.ALL'),
                                        dateStart: activeFilters.rangeDate[0] ? toBuddhistYear(moment(activeFilters.rangeDate[0]), 'DD/MM/YYYY') : '-',
                                        dateEnd: activeFilters.rangeDate[1] ? toBuddhistYear(moment(activeFilters.rangeDate[1]), 'DD/MM/YYYY') : '-',
                                        status: activeFilters.status === 'ALL' ? t('REPORT.FILTER.ALL') : activeFilters.status === 'WAITING' ? t('รอเบิกจ่าย') : t('เบิกจ่ายสำเร็จ'),
                                        t: t,
                                    });
                                } else if (e === 'PDF') {
                                    const style = document.createElement("style");
                                    style.innerHTML = `
                                          @media print {
                                            @page { size: landscape }
                                          }
                                        `;
                                    document.head.appendChild(style);
                                    window.print();
                                    document.head.removeChild(style);

                                }
                            }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                        </Box>
                    </Grid>
                </Grid>

                <Box marginTop="16px">
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType={sortType}
                        sortBy={sortBy}
                        onSort={onRequestSort}
                        setPageLimit={(limit) => setPageLimit(limit)}
                        setPage={(val) => setPage(val)}
                        rowCount={rowCount}
                        headCells={headCells}
                        rowsData={treatments.map((val: any, i: number) => {
                            return renderData(val, i, false)
                        })}
                        verticalAlign="Top"
                    />
                </Box>

                <Box
                    id="print-table-container"
                    ref={componentRef}
                >
                    <Typography fontSize="14px" fontWeight={400}>{t('จัดการข้อมูลย้อนหลังการรักษา (สิทธิ์ สปสช.)')}</Typography>
                    <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
                        <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.DATE_START')}: {rangeDateExcel[0] ? toBuddhistYear(moment(rangeDateExcel[0]), 'DD/MM/YYYY') : '-'}</Typography>
                        <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.DATE_END')}: {rangeDateExcel[1] ? toBuddhistYear(moment(rangeDateExcel[1]), 'DD/MM/YYYY') : '-'}</Typography>
                        <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.BRANCH')}: {branchIdExcel === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchIdExcel }), 'branchName') || _.get(_.find(branches, { branchId: branchIdExcel }), 'branchNameEn')}`}</Typography>
                        <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {statusExcel === 'ALL' ? t('STATUS.ALL') : statusExcel === 'WAITING' ? t('รอเบิกจ่าย') : t('เบิกจ่ายสำเร็จ')}</Typography>
                    </Box>
                    <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
                        <thead>
                            <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                                <th style={{ borderBottom: '1px solid black' }}>{t('TABLE.NO')}</th>
                                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('VN')}</th>
                                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('วันที่รับบริการ')}</th>
                                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('รหัสผู้ป่วย')}</th>
                                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('ชื่อผู้ป่วย')}</th>
                                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('การรักษา/บริการ')}</th>
                                <th style={{ borderBottom: '1px solid black', textAlign: 'right' }}>{t('ยอดค่าใช้จ่าย')}</th>
                                <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('สถานะเบิกจ่าย')}</th>
                                <th style={{ borderBottom: '1px solid black' }}>{t('ผู้บันทึก/เจ้าหน้าที่')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {exportData?.length === 0 &&
                                <tr>
                                    <td colSpan={9} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                                </tr>
                            }
                            {exportData.map((data: any, index: number) => (
                                <tr key={index}>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '120px' }}>{data?.vnNumber || '-'}</td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '100px' }}>{data?.date ? moment(data?.date).add(543, 'year').format('DD/MM/YYYY') : '-'}</td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '100px' }}>{data?.cnNumber || '-'}</td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '150px' }}>{data?.patientFullname || '-'}</td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>
                                        {renderDataExcel(data)}
                                    </td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'center', width: '100px' }}>{numberFormat(data?.price) || '-'}</td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '120px' }}>{data?.statusClaim === '1' ? 'รอเบิกจ่าย' : 'เบิกจ่ายสำเร็จ'}</td>
                                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center' }}>
                                        <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                                            <span>{data?.updatedBy || '-'}</span>
                                            <span>{dateTimeToView(data?.updatedAt) || '-'}</span>
                                        </Box>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
            </Box>
        </Box>
    )
}